import { render, staticRenderFns } from "./BiographiesVisual.vue?vue&type=template&id=ba37125e&scoped=true"
import script from "./BiographiesVisual.vue?vue&type=script&lang=js"
export * from "./BiographiesVisual.vue?vue&type=script&lang=js"
import style0 from "./BiographiesVisual.vue?vue&type=style&index=0&id=ba37125e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba37125e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
